// extracted by mini-css-extract-plugin
export default {"mainContainer":"modal_mainContainer__x144y","container":"modal_container__uvehE","close":"modal_close__Hh7Lb","content":"modal_content__7KClb"};